import { Injectable } from '@angular/core';
import { CommunicationBase } from 'src/app/models/communication';

@Injectable({
  providedIn: 'root'
})
export class SendReportService {

  isModalVisible() : boolean {
    get : {
      return !(this.communicationReport == null);
    }
  }

  communicationReport? : CommunicationBase;
  inputTypeId : number = 0; // select all = 0, whatsapp = 1, email = 2, print = 3, download = 4 //I am going to reuse this for the basic whatsapp template

  constructor() { }

  assignReport(rpt : CommunicationBase, typeId : number = 0) {
    this.communicationReport = rpt;
    this.inputTypeId = typeId;
  }

  removeReport() {
    this.communicationReport = undefined;
  }

  validEmail() : boolean {
    var re = /\S+@\S+\.\S+/;
    if (this.communicationReport && this.communicationReport.email) {
      return re.test(this.communicationReport?.email);
    } 
    else {
      return false;
    }
    
  }
}

